import { ProductDoc } from '@gooduncles/gu-app-schema';
import { ICellRendererParams } from 'ag-grid-community';
import { useEffect } from 'react';

import useSWRProduct from 'src/hooks/swr/useSWRProduct';

interface AgCellProductProps extends ICellRendererParams {
  productId: string;
  field: keyof ProductDoc;
}

const AgCellProduct = (params: AgCellProductProps) => {
  const productId = params.productId;
  const { product } = useSWRProduct(productId);
  const value = (product?.[params.field] ?? '') as string;

  useEffect(() => {
    if (params.setValue) {
      params.setValue(value);
    }
  }, [params, value]);

  return <span>{value}</span>;
};

export default AgCellProduct;
